import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validador para números IBAN (International Bank Account Number)
 * Valida el formato y el código de verificación usando el algoritmo mod-97
 */
export function ibanValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		if (!control.value) {
			return null; // No validar si está vacío (usar Validators.required si es obligatorio)
		}

		const iban = control.value.replace(/\s/g, '').toUpperCase();

		// Validar formato: 15-34 caracteres, comienza con 2 letras seguidas de 2 dígitos
		if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(iban)) {
			return { incorrectFormat: true };
		}

		// Validar el código de verificación usando mod-97
		if (!validateIBANChecksum(iban)) {
			return { ibanChecksum: true };
		}

		return null;
	};
}

/**
 * Valida el código de verificación IBAN usando el algoritmo mod-97
 */
function validateIBANChecksum(iban: string): boolean {
	// Mover los primeros 4 caracteres al final
	const rearranged = iban.slice(4) + iban.slice(0, 4);

	// Reemplazar letras por números (A=10, B=11, ..., Z=35)
	const numeric = rearranged.replace(/[A-Z]/g, (char) => {
		return String(char.charCodeAt(0) - 55);
	});

	// Validar usando mod-97
	return mod97(numeric) === 1;
}

/**
 * Calcula el módulo 97 de un número grande (representado como string)
 */
function mod97(numeric: string): number {
	let remainder = numeric;

	while (remainder.length > 2) {
		const block = remainder.slice(0, 9);
		remainder = String(Number(block) % 97) + remainder.slice(9);
	}

	return Number(remainder) % 97;
}
